<template>
    <div :class="item.classes">
        <template v-if="item.childs">
            <Dropdown class="editor-menubar__childs" :popper-options="{ placement: 'left' }">
                <template #label>
                    <component
                        :is="item.icon"
                        v-if="showIcon"
                        v-bind="{ fill: iconColor }"
                        class="editor-menubar__icon"
                    />
                </template>
                <template #items>
                    <li
                        v-for="(child, i) in item.childs"
                        :key="`editor-menu-child-${i}`"
                        class="dropdown__item"
                    >
                        <template v-if="child.component">
                            <component :is="child.component" :label="child.label" />
                        </template>
                        <template v-else-if="childRouteExists(child)">
                            <router-link :to="child.to">
                                <span class="editor-menubar__label" v-text="child.label" />
                            </router-link>
                        </template>
                        <template v-else>
                            <span class="editor-menubar__label" v-text="child.label" />
                        </template>
                    </li>
                </template>
            </Dropdown>
        </template>
        <template v-else-if="routeExists">
            <router-link :to="item.to" :title="item.label">
                <component
                    :is="item.icon"
                    v-if="showIcon"
                    v-bind="{ fill: iconColor }"
                    class="editor-menubar__icon"
                />
                <span v-if="showLabel" class="editor-menubar__label" v-text="item.label" />
            </router-link>
        </template>
        <template v-else>
            <span :title="item.label">
                <component
                    :is="item.icon"
                    v-if="showIcon"
                    v-bind="{ fill: iconColor }"
                    class="editor-menubar__icon"
                />
                <span v-if="showLabel" class="editor-menubar__label" v-text="item.label" />
            </span>
        </template>
    </div>
</template>

<script>
import Dropdown from '@speechki-frontend/shared/ui/Dropdown';

export default {
    components: {
        Dropdown,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        iconColor: {
            type: String,
            default: 'rgb(127, 127, 127)',
        },
    },
    computed: {
        showIcon() {
            return this.item.icon && this.item.options.showIcon;
        },
        showLabel() {
            return this.item.label && this.item.options.showLabel;
        },
        // switcher-only items point at route names that don't exist;
        // vue-router 4 throws on resolving them (v3 rendered a dead link)
        routeExists() {
            return !!(
                this.item.to &&
                this.item.to.name &&
                this.$router.hasRoute(this.item.to.name)
            );
        },
    },
    methods: {
        childRouteExists(child) {
            return !!(child.to && child.to.name && this.$router.hasRoute(child.to.name));
        },
    },
};
</script>
